import React from 'react';

import { ICombo, IItem, IPicker } from '@rbi-ctg/menu';
import FormatMenuPrice from 'components/menu-utils/format-menu-price';
import { EventName, emitEvent } from 'utils/event-hub';
import { routes } from 'utils/routing';

import { ITileClickedEvent, MainMenuObject } from './types';

interface IFormattedCaloriesAndPriceRangeForMenuObject {
  (
    menuObject: IPicker | MainMenuObject,
    getCaloriesRange: (menuObject: ICombo | IItem | IPicker | MainMenuObject) => string,
    getPrices: (menuObject: ICombo | IItem | IPicker | MainMenuObject) => React.ReactNode
  ): { calories: string; price: React.ReactNode };
}

const formattedCaloriesAndPriceRangeForMenuObject: IFormattedCaloriesAndPriceRangeForMenuObject = (
  menuObject,
  getCaloriesRange,
  getPrices
) => {
  const price = getPrices(menuObject);
  return {
    calories: getCaloriesRange(menuObject),
    price,
  };
};

interface IGetCaloriesAndPrice {
  (
    menuObject: IPicker | MainMenuObject,
    getCaloriesRange: (menuObject: ICombo | IItem) => string
  ): { calories: string; price: React.ReactNode };
}

export const getCaloriesAndPrice: IGetCaloriesAndPrice = (menuObject, getCaloriesRange) => {
  const getPrices = (comboOrItem: ICombo | IItem) => {
    return <FormatMenuPrice menuItem={comboOrItem} />;
  };

  return formattedCaloriesAndPriceRangeForMenuObject(
    menuObject,
    // @ts-expect-error TS(2345) FIXME: Argument of type '(menuObject: IItem | ICombo, dis... Remove this comment to see the full error message
    getCaloriesRange,
    getPrices
  );
};

export const emitTileClickedEvent = ({ sanityId, pathname }: ITileClickedEvent) => {
  emitEvent(EventName.MENU_TILE_CLICKED, {
    sanityId,
    isOnMainMenu: pathname === routes.menu,
  });
};
